export default __webpack_public_path__ + "static/media/meddi.aa5d3189.svg";